import React from "react";
import { MapContainer, CircleMarker, TileLayer, Tooltip } from "react-leaflet";
import { getMapBounds } from "../../utils/helpers.js";
import "leaflet/dist/leaflet.css";

const LocationMap = (props) => {
  const divStyle = {
    width: "100%",
    height: "100%",
  };

  const centerLat = (props.mapInfo.minLat + props.mapInfo.maxLat) / 2;
  const distanceLat = props.mapInfo.maxLat - props.mapInfo.minLat;
  const bufferLat = distanceLat * 0.05;
  const centerLong = (props.mapInfo.minLong + props.mapInfo.maxLong) / 2;
  const distanceLong = props.mapInfo.maxLong - props.mapInfo.minLong;
  const bufferLong = distanceLong * 0.15;
  const bounds = getMapBounds(getMapBounds(props.mapData));

  return (
    <div style={divStyle}>
      <MapContainer
        dragging={true}
        style={{ height: "480px", width: "auto" }}
        zoom={1}
        attributionControl={false}
        center={[centerLat, centerLong]}
        bounds={[
          [
            props.mapInfo.minLat - bufferLat,
            props.mapInfo.minLong - bufferLong,
          ],
          [
            props.mapInfo.maxLat + bufferLat,
            props.mapInfo.maxLong + bufferLong,
          ],
        ]}
      >
        <TileLayer url="http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {props.mapData.map((city, k) => {
          return (
            <CircleMarker
              key={k}
              center={[city["coordinates"][1], city["coordinates"][0]]}
              radius={40 * Math.log(city["invoice_amount"] / 10000000)}
              fillOpacity={0.5}
              stroke={false}
            >
              <Tooltip direction="right" offset={[-8, -2]} opacity={1}>
                <span>
                  {city["supplier_site"] +
                    ": " +
                    "Invoice Amount" +
                    " " +
                    city["invoice_amount"]}
                </span>
              </Tooltip>
            </CircleMarker>
          );
        })}
      </MapContainer>
    </div>
  );
};

export default LocationMap;
